import defer from './defered';

const ENV = '<@prod@>';
const VERSION = '<@AUTOTRACKER_VERSION@>';
const MINIFIED = ENV === 'PROD' ? '.min' : '';
const SRC = `//<@SDK_CDN@>/versioned/${VERSION}/pulse${MINIFIED}.js`;

window.pulse =
  window.pulse ||
  ((...rest) => {
    const promise = defer(rest);
    // biome-ignore lint/suspicious/noAssignInExpressions: -
    (window.pulse.q = window.pulse.q || []).push(promise);
    return promise;
  });

window.pulse.q = window.pulse.q || [];

const script = document.createElement('script');
const b = document.getElementsByTagName('script')[0];
script.async = 1;
script.src = SRC;
b.parentNode.insertBefore(script, b);
